import React, { useEffect, useState } from "react";
import { Stack, Typography } from "@mui/material";
import { postRequest } from "../../../services/api";
import { ASN_DATE_WISE_DATA } from "../../../constants";
import BarChart from "../../../components/BarChart";
import { sumData } from "../../../utils";
import { useSelector } from "react-redux";

const DateWiseShipment = () => {
  const { startDate, endDate } = useSelector((state) => state.dashboard);
  const { user, userSetting } = useSelector((state) => state.user);

  const [data, setData] = useState(ASN_DATE_WISE_DATA);
  const [chartData, setChartData] = useState([]);

  const dateWiseFormat = (data) => {
    const arrayResultByDay = sumData(data, "forWeek", 'asOnDate', 'cnt');
    setChartData(arrayResultByDay);
  };

  useEffect(() => {
    dateWiseFormat(data);
  }, [data]);


  const fetchDateWiseShipmentData = async () => {
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user.token}`,
    };
    let payload = {
      custCode: userSetting[0].currCustomer,
      fromDate: startDate.format("YYYY-MM-DD"),
      toDate: endDate.format("YYYY-MM-DD"),
    };
    const response = await postRequest(
      "user/getDashCount_containers",
      payload,
      headers
    );
    setData(response.data.Payload);
  };

  useEffect(() => {
    fetchDateWiseShipmentData();
  }, [startDate, endDate, userSetting]);

  return (
    <div>
      <Stack
        direction="row"
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <Typography>Container</Typography>
      </Stack>

      <BarChart chartName={"Date Wise Container"} chartData={chartData} name="Count" yAxisLabel="count" xAxisLabel="Week"/>
    </div>
  );
};

export default DateWiseShipment;
